// extracted by mini-css-extract-plugin
export var img = "banner-module--img--vZy-L";
export var imgfade = "banner-module--imgfade--tPj9J";
export var text = "banner-module--text---jmZf";
export var textContainer = "banner-module--textContainer--1n1hg";
export var textfade = "banner-module--textfade--a3vka";
export var wrapper = "banner-module--wrapper--eu8xI";